/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2013, 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([ 'jquery' ],function($) {

	// Utility class for interaction actions
	class Utils {
		/**
		 * Set the top and left of a node
		 * @param node
		 * @param top
		 * @param left
		 * @returns
		 */
		static setTopLeft(node, top, left) {
			// TODO: Verify whether we need to use window.requestAnimationFrame for better animation. Does seem to make things look bad on touch devices.
			node.style.left = left + 'px';
			node.style.top = top + 'px';

		}

		/**
		 * Get a style value and convert it to an integer
		 * @param style
		 * @returns
		 */
		static getStyleIntValue(style) {
			var value = parseFloat(style);
			return isNaN(value) ? 0 : Math.round(value);
		}

		static removeEvents(aHandlers) {
			for ( var i = 0; i < aHandlers.length; i++) {
				aHandlers[i].off();
			}
		}

		/**
		 * Get the position of a node.
		 *
		 * @param n
		 * @returns
		 */
		static position(n) {
			var cs = window.getComputedStyle(n);
			var currentTop = n.offsetTop - this.getStyleIntValue(cs.marginTop);
			var currentLeft = n.offsetLeft - this.getStyleIntValue(cs.marginLeft);
			return {
				'top': currentTop,
				'left': currentLeft
			};
		}

		/**
		 * Return the widget bounds. We return the outer height/width because the box model of the widget is using border-sizing
		 *
		 */
		static widgetSize(n){
			var $n = $(n);

			return {
				height: $n.outerHeight(),
				width: $n.outerWidth()
			};
		}

		/**
		 * Get the content of a node without including the decoration that is added for interaction (e.g. resizebox, resize edge)
		 * @param n
		 * @returns
		 */
		static getContentWithoutDecoration(n) {
			return $(n).children('*:not(.selectionBox, .resizeEdge, .resizeBox)');
		}

		/**
		 * Get the angle from the CSS transform in radian
		 *
		 * @param div
		 * @returns
		 */
		static getAngleRadian(div) {

			// Sometimes getting the transform value give low values like -4.37114e-008 for what is actually 0.
			var _checkIfZero = (i) => {
				if (Math.abs(i) < 0.0000001) {
					return 0;
				}
				return i;
			};

			var angle = 0;

			try {
				var s = window.getComputedStyle(div, null);
				var t = s.getPropertyValue('-webkit-transform') || s.getPropertyValue('-moz-transform') || s.getPropertyValue('-ms-transform');
				t = t || s.getPropertyValue('-o-transform') || s.getPropertyValue('transform');

				if (t && t.indexOf(',')>0) {
					var v = t.split('(')[1].split(')')[0].split(',');

					var y = _checkIfZero(v[1]);
					var x = _checkIfZero(v[0]);

					angle = Math.atan2(y, x);
				}
			} catch (e) {
				console.warn(e);
			}

			return angle;
		}

		static getAngleFromMatrix(matrixStr) {
			let angle = 0;
			if(matrixStr && matrixStr !== 'none') {
				const matrixValueStr = matrixStr.split('(')[1];
				if (matrixValueStr) {
					const values = matrixValueStr.split(')')[0].split(',');
					const a = values[0];
					const b = values[1];
					angle = Math.round(this.radianToDegree(Math.atan2(b, a)));
				}
			}
			return ((angle % 360) + 360) % 360;
		}

		/**
		 * Get the angle relative the document body or parent parameter if provided from the CSS transform in radian.
		 * This angle is the angle of the element combined with the angles of all parents.
		 *
		 * @param node
		 * @param parent
		 * @returns
		 */
		static getAbsoluteAngleRadian(node, parent) {
			var $p = $(node).parents();
			var angle = this.getAngleRadian(node);
			var p;
			for ( var i = 0, iLen = $p.length; i < iLen; i++) {
				p = $p[i];
				angle += this.getAngleRadian(p);
				if (parent === p){
					break;
				}
			}

			return angle;
		}

		/**
		 * Get the angle from the CSS transform in degree
		 *
		 * @param div
		 * @returns
		 */
		static getAngleDegree(div) {
			return this.radianToDegree(this.getAngleRadian(div));
		}

		/**
		 *  Convert radian to degrees
		 *
		 * @param radian
		 * @returns
		 */
		static radianToDegree(radian) {
			return radian * (180 / Math.PI);
		}

		/**
		 * Set the rotate CSS transform
		 *
		 * @param node
		 * @param angle
		 * @returns
		 */
		static setRotateTransform(node, angle) {
			var t = 'rotate(' + angle + 'deg)';
			var s = node.style;
			s.transform = t;
			s.oTransform = t;
			s.msTransform = t;
			s.mozTransform = t;
			s.webkitTransform = t;
		}

		/**
		 * Get the coordinates of the center of a given node
		 *
		 * @param node
		 * @returns {object}
		 */
		static getCenter(node) {
			return this.getRectCenter(node.getBoundingClientRect());
		}

		/**
		 * Get the coordinates of the center of a rectangle
		 *
		 * @param rect
		 * @returns {object}
		 */
		static getRectCenter(rect) {
			return {
				'left': Math.round(rect.left) + ( Math.round(rect.width) / 2),
				'top': Math.round(rect.top) + ( Math.round(rect.height) / 2),
				'height': rect.height,
				'width': rect.width
			};
		}

		/**
		 * Get the rotated coordinates relative to the axis node.
		 * The coordinate will be relative to the axis with the center at the top/left of the axis node taking into account the angle of that node.
		 *
		 * @param axisNode
		 * @param clientX
		 * @param clientY
		 * @returns
		 */
		static getRotatedCoordinates(axisNode, clientX, clientY, rect) {
			var angle = Math.PI / 2 - this.getAbsoluteAngleRadian(axisNode);
			var center = rect ? this.getRectCenter(rect) : this.getCenter(axisNode);
			var x0 = clientX - center.left;
			var y0 = clientY - center.top;
			var h = center.height;
			var w = center.width;

			return {
				'x': Math.round(w / 2 + (x0 * Math.sin(angle) + y0 * Math.cos(angle))),
				'y': Math.round( h / 2 + (y0 * Math.sin(angle) - x0 * Math.cos(angle)))
			};
		}

		/**
		 * Helper function that returns the min/max left and top of a list of nodes.
		 * @param nodes
		 * @param getRectFunction
		 * @returns {object} object that contains the minTop, maxTop, minLeft, maxLeft
		 *
		 */
		static getMinMaxTopLeft(nodes, getRectFunction){
			var result = {};
			var i, iLen, n, pos, rect;
			for (i = 0, iLen = nodes.length; i < iLen; i++) {
				n = nodes[i];
				rect = getRectFunction(n);
				if (result.minTop === undefined || rect.top < result.minTop) {
					result.minTop = rect.top;
				}
				if (result.minLeft === undefined || rect.left < result.minLeft) {
					result.minLeft = rect.left;
				}

				pos = rect.top + rect.height;
				if (result.maxTop === undefined || pos > result.maxTop) {
					result.maxTop = pos;
				}

				pos = rect.left + rect.width;
				if (result.maxLeft === undefined || pos > result.maxLeft) {
					result.maxLeft = pos;
				}
			}
			return result;

		}

		static getNodes(controller, idList) {
			const nodes = [];
			if (idList && idList.length) {
				idList.forEach(id => {
					const layoutView = controller.layoutController.getLayoutView(id);
					if (layoutView && layoutView.domNode) {
						nodes.push(layoutView.domNode);
					}
				});
			}
			return nodes;
		}

	}

	return Utils;

});
